/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOrganizationRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetOrganizationSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationSecurity$outboundSchema: z.ZodMiniType<
  GetOrganizationSecurity$Outbound,
  GetOrganizationSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getOrganizationSecurityToJSON(
  getOrganizationSecurity: GetOrganizationSecurity,
): string {
  return JSON.stringify(
    GetOrganizationSecurity$outboundSchema.parse(getOrganizationSecurity),
  );
}

/** @internal */
export type GetOrganizationRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationRequest$outboundSchema: z.ZodMiniType<
  GetOrganizationRequest$Outbound,
  GetOrganizationRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getOrganizationRequestToJSON(
  getOrganizationRequest: GetOrganizationRequest,
): string {
  return JSON.stringify(
    GetOrganizationRequest$outboundSchema.parse(getOrganizationRequest),
  );
}
